import { LauncherTableInfo } from './types';

export enum LauncherActionType {
  ADD_TABLE = 'ADD_TABLE',
  REMOVE_TABLE = 'REMOVE_TABLE',
  SET_TABLES = 'SET_TABLES',
  SET_ACTIVE_TABLE = 'SET_ACTIVE_TABLE',
  SET_OPERATOR_GAME_ID = 'SET_OPERATOR_GAME_ID',
  OPEN_LOBBY = 'OPEN_LOBBY',
  OPEN_MTB = 'OPEN_MTB',
  LOBBY_LOADED = 'LOBBY_LOADED',
  LOBBY_CLOSED = 'LOBBY_CLOSED',
  TOGGLE_MTB = 'TOGGLE_MTB',
  GAME_LOADED = 'GAME_LOADED',
  REPLACE_TABLE = 'REPLACE_TABLE',
  BASE_TABLE_CHANGED = 'BASE_TABLE_CHANGED',
}

// payload types
interface SetTablePayload {
  tables: LauncherTableInfo[];
}
interface BaseLauncherPayload {
  tableId: string;
}
interface OperatorGameIdPayload {
  operatorGameId: string;
  tableId: string;
}
interface AddMtbPayload {
  url: string;
}

interface ToggleMtbPayload {
  isMinimize: boolean;
}

interface ReplaceTablePayload {
  url: string;
  operatorGameId: string;
  tableId: string;
}

// action types
interface BaseLauncherAction<T, U = undefined> {
  type: T;
  payload?: U;
}

type SetTableAction = BaseLauncherAction<LauncherActionType.SET_TABLES, SetTablePayload>;
type AddTableAction = BaseLauncherAction<LauncherActionType.ADD_TABLE, LauncherTableInfo>;
type RemoveTableAction = BaseLauncherAction<LauncherActionType.REMOVE_TABLE, BaseLauncherPayload>;
type SetActiveTableAction = BaseLauncherAction<LauncherActionType.SET_ACTIVE_TABLE, BaseLauncherPayload>;
type OpenLobbyAction = BaseLauncherAction<LauncherActionType.OPEN_LOBBY>;
type AddMtbAction = BaseLauncherAction<LauncherActionType.OPEN_MTB, AddMtbPayload>;
type LobbyLoadedAction = BaseLauncherAction<LauncherActionType.LOBBY_LOADED>;
type LobbyClosedAction = BaseLauncherAction<LauncherActionType.LOBBY_CLOSED>;
type GameLoadedAction = BaseLauncherAction<LauncherActionType.GAME_LOADED>;
type SetOperatorGameIdAction = BaseLauncherAction<LauncherActionType.SET_OPERATOR_GAME_ID, OperatorGameIdPayload>;
type ToggleMTBAction = BaseLauncherAction<LauncherActionType.TOGGLE_MTB, ToggleMtbPayload>;
type ReplaceTableAction = BaseLauncherAction<LauncherActionType.REPLACE_TABLE, ReplaceTablePayload>;
type BaseTableChangedAction = BaseLauncherAction<LauncherActionType.BASE_TABLE_CHANGED, BaseLauncherPayload>;

// action creators
export const launcherContextActions = {
  setTables: (payload: SetTablePayload): SetTableAction => ({
    type: LauncherActionType.SET_TABLES,
    payload,
  }),
  addTable: (payload: LauncherTableInfo): AddTableAction => ({
    type: LauncherActionType.ADD_TABLE,
    payload,
  }),
  removeTable: (payload: BaseLauncherPayload): RemoveTableAction => ({
    type: LauncherActionType.REMOVE_TABLE,
    payload,
  }),
  setActiveTable: (payload: BaseLauncherPayload): SetActiveTableAction => ({
    type: LauncherActionType.SET_ACTIVE_TABLE,
    payload,
  }),
  openLauncherMTB: (payload: AddMtbPayload): AddMtbAction => ({
    type: LauncherActionType.OPEN_MTB,
    payload,
  }),
  openLauncherLobby: (): OpenLobbyAction => ({
    type: LauncherActionType.OPEN_LOBBY,
  }),
  lobbyLoaded: (): LobbyLoadedAction => ({
    type: LauncherActionType.LOBBY_LOADED,
  }),
  lobbyClosed: (): LobbyClosedAction => ({
    type: LauncherActionType.LOBBY_CLOSED,
  }),
  gameLoaded: (): GameLoadedAction => ({
    type: LauncherActionType.GAME_LOADED,
  }),
  setOperatorGameId: (payload: OperatorGameIdPayload): SetOperatorGameIdAction => ({
    type: LauncherActionType.SET_OPERATOR_GAME_ID,
    payload,
  }),
  toggleMtb: (payload: ToggleMtbPayload): ToggleMTBAction => ({
    type: LauncherActionType.TOGGLE_MTB,
    payload,
  }),
  replaceTable: (payload: ReplaceTablePayload): ReplaceTableAction => ({
    type: LauncherActionType.REPLACE_TABLE,
    payload,
  }),
  changeBaseTable: (payload: BaseLauncherPayload): BaseTableChangedAction => ({
    type: LauncherActionType.BASE_TABLE_CHANGED,
    payload,
  }),
};

// actions export
export type LauncherAction =
  | SetTableAction
  | AddTableAction
  | AddMtbAction
  | RemoveTableAction
  | SetActiveTableAction
  | OpenLobbyAction
  | LobbyLoadedAction
  | LobbyClosedAction
  | GameLoadedAction
  | SetOperatorGameIdAction
  | ToggleMTBAction
  | BaseTableChangedAction
  | ReplaceTableAction;
